import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PagesService } from './pages.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private dataSubject = new BehaviorSubject<any>(null);
  public data$ = this.dataSubject.asObservable();

  http = inject(HttpClient);
  pagesService = inject(PagesService);
  sharedService = inject(SharedService);

constructor() {
    this.getContestLists();  // ✅ Auto call once when service is created
  }

  getContestLists() {
    this.sharedService.showLoader();
    this.pagesService.getAll('GET_ALL_CONTESTS').subscribe({
      next: (response) => {
        this.sharedService.hideLoader();
        this.dataSubject.next(response.data); // ✅ Store data

      },
      error: (error) => {
        this.sharedService.hideLoader();
        this.sharedService.createNotification(error, error);
      },
    });
  }

  // ✅ Public method to refresh contest data (e.g., after update/create)
  refreshContestData() {
    this.getContestLists();
  }
}
